import { render, staticRenderFns } from "./RecommendUserForProjects.vue?vue&type=template&id=21eda209&scoped=true"
import script from "./RecommendUserForProjects.vue?vue&type=script&lang=ts"
export * from "./RecommendUserForProjects.vue?vue&type=script&lang=ts"
import style0 from "./RecommendUserForProjects.vue?vue&type=style&index=0&id=21eda209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eda209",
  null
  
)

export default component.exports